import React from 'react';

import styles from './titleContent.module.scss'

const TitleContent = props => {
  const { title } = props

  return (
    <div className={styles.titleContent}>
      <span className={styles.firstTitle}>{title}</span>
    </div>
  )
}

export default React.memo(TitleContent)
